import OSS from 'ali-oss';
import CryptoJS from 'crypto-js';

/**
 * OSS 上传工具类
 */
class OSSUploader {
  /**
   * 初始化OSS客户端
   * @param {Object} OSS配置
   * @param {string} region - OSS区域
   * @param {string} accessKeyId - AccessKey ID
   * @param {string} accessKeySecret - AccessKey Secret
   * @param {string} bucket - 存储桶名称
   * @param {string} [config.endpoint] - 自定义端点（可选）
   * @returns {OSS} OSS客户端实例
   */
  static initClient() {
    return new OSS({  
      region: 'beijing',
      accessKeyId: "LTAI5tNj7NYjtAHJWGdtgVXq",
      accessKeySecret: "8qVztYDAfToTzTVPZEpwytUTPsUYfF",
      bucket: "huarong-img",
      endpoint: "oss-cn-beijing.aliyuncs.com",
      secure: true // 强制使用HTTPS
    });
  }

  /**
   * 生成唯一文件名
   * @param {File} file - 文件对象
   * @param {string} [prefix=''] - 自定义前缀
   * @returns {string} 生成的文件名
   */
  static generateFileName(file, prefix = '') {
    const timestamp = Date.now();
    const randomStr = CryptoJS.lib.WordArray.random(8).toString(CryptoJS.enc.Hex);
    const ext = file.name.split('.').pop();
    return `${prefix}${timestamp}_${randomStr}.${ext}`.toLowerCase();
  }

  /**
   * 上传文件到OSS
   * @param {OSS} client - OSS客户端实例
   * @param {File} file - 要上传的文件
   * @param {Object} [options] - 上传选项
   * @param {string} [options.prefix=''] - 文件前缀
   * @param {string} [options.dir=''] - 存储目录
   * @param {Object} [options.meta] - 文件元信息
   * @returns {Promise<{url: string, name: string}>} 上传结果
   */
  static async upload(client, file, options = {}) {
    const { prefix = '', dir = '', meta = {} } = options;
    const fileName = this.generateFileName(file, prefix);
    const fullPath = dir ? `${dir}/${fileName}` : fileName;

    try {
      const result = await client.put(fullPath, file, { meta });
      return {
        url: result.url,
        name: fileName,
        fullPath,
        res: result.res
      };
    } catch (error) {
      console.error('OSS上传失败:', error);
      throw new Error('文件上传失败，请稍后重试');
    }
  }

  /**
   * 批量上传文件
   * @param {OSS} client - OSS客户端实例
   * @param {File[]} files - 文件数组
   * @param {Object} [options] - 上传选项
   * @returns {Promise<Array<{url: string, name: string}>>} 上传结果数组
   */
  static async uploadAll(client, files, options = {}) {
    return Promise.all(files.map(file => this.upload(client, file, options)));
  }

  /**
   * 获取预下载链接
   * @param {OSS} client - OSS客户端实例
   * @param {File[]} fileName - 文件名称
   */
  static async getOssDownloadUrl(client,fileName) {
    const actualFileName = fileName.includes('/') 
      ? fileName.split('/').pop() 
      : fileName;
    console.log(actualFileName)
    // 使用 signatureUrl 方法，参数格式调整
    return client.signatureUrl(fileName, {
              expires: 3600,       // 有效期（秒）
              method: 'GET',       // HTTP 方法
              contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
              response: {
                  'content-disposition': `attachment; filename="${encodeURIComponent(actualFileName)}"`,
                  // 建议根据实际文件类型动态设置（或移除此行让OSS自动识别）
                  // 'content-type': 'application/octet-stream' 
              }
          });
  }


}

export default OSSUploader;